import { render, staticRenderFns } from "./major-list.vue?vue&type=template&id=5846802a&scoped=true&"
import script from "./major-list.vue?vue&type=script&lang=js&"
export * from "./major-list.vue?vue&type=script&lang=js&"
import style0 from "./major-list.vue?vue&type=style&index=0&id=5846802a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846802a",
  null
  
)

export default component.exports